import {connect} from 'react-redux';
import Step3 from './Step3';
import {submitStep} from '../../actions/submitStep';
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           stepPayload: {payload},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  payload,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {submitStep, prevCompletedStepSignFalse}
)(Step3);
